module.exports = __webpack_public_path__ + "static/media/priorityIcon.8c50e6e1.svg";